import axios from 'axios';
import { getCookie, COOKIES } from 'src/utils/cookie';

const instance = axios.create({
  baseURL: window.API_BASE_URL,
});

const AUTH_TOKEN = getCookie(COOKIES.AUTH_SERVICE_TOKEN);

instance.defaults.headers.common['Authorization'] = `Bearer ${AUTH_TOKEN}`;
instance.defaults.headers.post['Content-Type'] = 'application/json';

const reqInterceptor = instance.interceptors.request.use(
  request => {
    console.log('[INTERCEPTOR_REQUEST]:', request);
    return request;
  },
  error => {
    console.log('[INTERCEPTOR_REQUEST][ERROR]:', error);
    return Promise.reject(error);
  },
); // only for errors that request sending failed. For respond error use next

instance.interceptors.request.eject(reqInterceptor);

const respInterceptor = instance.interceptors.response.use(
  response => {
    console.log('[INTERCEPTOR_RESPONSE]:', response);
    return response;
  },
  error => {
    console.log('[INTERCEPTOR_RESPONSE][ERROR]:', error);
    return Promise.reject(error);
  },
);

instance.interceptors.response.eject(respInterceptor);

export const CancelToken = axios.CancelToken;

export default instance;
